import { atom } from 'nanostores'

export const $isTrialTimelineViewOpen = atom<boolean>(false)

export const openTrialTimelineView = () => {
  $isTrialTimelineViewOpen.set(true)
}

export const closeTrialTimelineView = () => {
  $isTrialTimelineViewOpen.set(false)
}
